import React, { PureComponent } from 'react';

import Toolbar from './toolbar';
import Logo from './logo';
import PhonesDesk from './phonesdesk';
import HoursOperation from './hoursoperation';
import NavBar from './navbar';

class Header extends PureComponent {
    render() {
        return (
            <header className="header">
                <Toolbar/>
                <div className="container">
                    <div className="row">
                        <div className="col-3">
                            <Logo/>
                        </div>
                        <div className="col-9">
                            <div className="row justify-content-end">
                                <div className="col-5">
                                    <PhonesDesk/>
                                </div>
                                <div className="col-5">
                                    <HoursOperation/>
                                </div>
                            </div>                        
                        </div>
                        <div className="col">
                            <NavBar/>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header